const map = {
	"./de/translation.json": [
		795,
		[
			795
		]
	],
	"./en/translation.json": [
		3219,
		[
			219
		]
	],
	"./fr/translation.json": [
		3768,
		[
			768
		]
	],
	"./fr/translation_OLD.json": [
		2994,
		[
			994
		]
	],
	"./pt/translation.json": [
		1620,
		[
			620
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4766;
module.exports = webpackAsyncContext;